import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";
import config from "../../../config";

import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";

import messages from "../../../redux/messages";
import SidebarEvaluacionDesempenio from "../../../components/evaluacion_desempenio/SidebarEvaluacionDesempenio";
import SidebarDashboard from "../../../components/SidebarDashboard";
import {
  deleteFactor,
  editFactor,
  getFactor,
  resetFactor,
  saveFactor,
} from "../../../redux/evaluacion_desempenio/Factor/actions";
import { useHistory } from "react-router-dom";
import {
  getClassification,
  saveClassification,
  editClassification,
  deleteClassification,
} from "../../../redux/Classification/actions";
import { getOrgs } from "../../../redux/organization/actions";
import {
  getPeriodicity,
  getPeriodicityByOrg,
  resetPeriodicity,
  resetPeriodicityByOrg,
} from "../../../redux/evaluacion_desempenio/Periodicity/actions";
import { getFactorName } from "../../../redux/evaluacion_desempenio/FactorName/actions";

const Factor = (props) => {
  // const filters = [
  //   { id: "descripcion", desc: "Desempeño" },
  //   { id: "puntos", desc: "Puntos" },
  // ];

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [totalPesos, setTotalPesos] = useState(0);
  const [totalPesosT, setTotalPesosT] = useState(0);
  const [desempeñoT, setDesempeñoT] = useState(false);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const userRoles = useSelector((store) => store.auth.userRoles);
  const [_clasificacion, setClasificacion] = useState("");
  const [_empresa, setEmpresa] = useState("");
  const [_periodo, setPeriodo] = useState("");
  const [isClasiSelect, setIsClasiSelect] = useState(false);
  const [isOrgSelect, setIsOrgSelect] = useState(false);
  // const [tipoBusqueda, setTipoBusqueda] = useState({
  //   id: "descripcion",
  //   desc: "Desempeño",
  // });

  const dataClasificacion = useSelector(
    (store) => store.classification.classification
  );
  const loadingClasificacion = useSelector(
    (store) => store.classification.loading
  );
  const { tipo_factor } = config;

  const fecha = new Date();
  var n = fecha.getFullYear();
  const dispatch = useDispatch();
  const history = useHistory();

  const schema = Yup.object().shape({
    // nombre: Yup.string()
    //   .matches(/[\w]/, "Formato no correcto")
    //   .required("**Campo requerido"),
    factor: Yup.string().required("**Campo requerido"),
    peso: Yup.number()
      .integer("El número no puede tener decimales.")
      .min(0, "El valor minimo es 0.")
      .max(100, "El valor maximo es 100.")
      .required("**Campo requerido"),
    tipo_factor: Yup.string().required("**Campo requerido"),
    clasificacion: Yup.string().notRequired(),
    empresa: Yup.string().notRequired(),
    // desempeno_esperado: Yup.number()
    //   .integer("El número no puede tener decimales.")
    //   .min(0, "El valor minimo es 0.")
    //   .max(100, "El valor maximo es 100.")
    //   .required("**Campo requerido"),
  });

  const {
    loading,
    saveLoading,
    factorsLength,
    factors,
    factorError,
    formError,
  } = useSelector((store) => store.factor);
  const pages = Math.ceil(factorsLength / limit);

  const {
    loading: loadingPeriodicity,
    saveLoading: saveLoadingPeriodicity,
    periodicity,
    periodicityError,
    formError: formErrorPeriodicity,
    periodicitys,
    loadingPeriodicitys,
  } = useSelector((store) => store.periodicity);

  const data = useSelector((store) => store.orgs.orgs);
  const loadingOrgs = useSelector((store) => store.orgs.loading);

  const {
    loading: loadingFactorName,
    saveLoading: saveLoadingFactorName,
    factorName,
    factorNameError,
    formError: factorNameformError,
  } = useSelector((store) => store.factorName);

  const columns = [
    {
      Header: "Empresa",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.periodicidad
            ? value.row.original.list_periodicidad[0].list_empresa[0].nombre
            : ""}
        </div>
      ),
    },
    {
      Header: "Clasificación",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.list_clasificacion
            ? value.row.original.list_clasificacion[0].nombre
            : ""}
        </div>
      ),
    },
    // {
    //   Header: "Nombre",
    //   accessor: "nombre",
    //   Filter: "",
    // },
    {
      Header: "Factor",
      // accessor: "peso",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.factor
            ? value.row.original.list_factor[0].nombre
            : "No ingresado"}
        </div>
      ),
    },
    {
      Header: "Peso",
      accessor: "peso",
      Filter: "",
      Cell: (value) => <div>{value.row.original.peso}</div>,
    },
    // {
    //   Header: "Desempeno esperado",
    //   accessor: "desempeno_esperado",
    //   Filter: "",
    //   Cell: (value) => <div>{value.row.original.desempeno_esperado}</div>,
    // },
    {
      Header: "Tipo:",
      // accessor: "list_estado[0].nombre_estado",
      Filter: "",
      Cell: (value) => (
        <div
          className="py-2 px-3 rounded-pill text-white text-between"
          style={{
            backgroundColor: tipo_factor.find(
              (e) => e.tipo === value.row.original.tipo_factor
            ).color,
            minWidth: "110px",
            maxWidth: "250px",
          }}
        >
          {
            tipo_factor.find((e) => e.tipo === value.row.original.tipo_factor)
              .tipo
          }{" "}
          -{" "}
          {
            tipo_factor.find((e) => e.tipo === value.row.original.tipo_factor)
              .abrev
          }
        </div>
      ),
    },
    {
      Header: "Fecha de cierre",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.periodicidad
            ? moment(value.row.original.list_periodicidad[0].fecha_fin).format(
                "DD/MM/YYYY"
              )
            : ""}
        </div>
      ),
    },
    {
      Header: "Fecha creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  const columnsEval = [
    {
      Header: "Nombre",
      accessor: "nombre_factor",
      Filter: "",
    },
    {
      Header: "Peso",
      accessor: "peso",
      Filter: "",
      Cell: (value) => <div>{value.row.original.peso}</div>,
    },
    // {
    //   Header: "Desempeno esperado",
    //   accessor: "desempeno_esperado",
    //   Filter: "",
    //   Cell: (value) => <div>{value.row.original.desempeno_esperado}</div>,
    // },
    {
      Header: "Tipo:",
      // accessor: "list_estado[0].nombre_estado",
      Filter: "",
      Cell: (value) => (
        <div
          className="py-2 px-3 rounded-pill text-white text-between"
          style={{
            backgroundColor: tipo_factor.find(
              (e) => e.tipo === value.row.original.tipo_factor
            ).color,
            minWidth: "110px",
            maxWidth: "250px",
          }}
        >
          {
            tipo_factor.find((e) => e.tipo === value.row.original.tipo_factor)
              .tipo
          }{" "}
          -{" "}
          {
            tipo_factor.find((e) => e.tipo === value.row.original.tipo_factor)
              .abrev
          }
        </div>
      ),
    },
    {
      Header: "Fecha creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          {value.row.original.tipo_factor === 0 ? (
            <>
              <Button
                size="sm"
                variant="link"
                type="button"
                onClick={() => onEdit(value.row.original, value.row.index)}
              >
                <i className="material-icons">edit</i>
              </Button>
            </>
          ) : null}
        </div>
      ),
    },
  ];

  // Métodos
  const _getFactor = (
    offs = offset,
    lim = limit,
    filt = filter,
    clasi = _clasificacion,
    period = _periodo
  ) =>
    dispatch(
      getFactor(
        props.match.params.id
          ? { id: parseInt(props.match.params.id) }
          : {
              offset: offs,
              limit: lim,
              tipo_busqueda: "periodicidad",
              filter: period,
              tipo_busqueda_2: "clasificacion",
              filter_2: clasi,
              tipo_busqueda_3: "nombre",
              filter_3: filt,
            },
        props.match.params.id
      )
    );
  useEffect(() => {
    setEmpresa("");
    setPeriodo("");
    setFilter("");
    dispatch(resetFactor());
    setClasificacion("");
    getAClassification({});
    dispatch(getOrgs(parseInt(2)));
    dispatch(resetFactor());
    dispatch(resetPeriodicity());
    dispatch(resetPeriodicityByOrg());
    dispatch(getFactorName({}));
  }, []);

  useEffect(() => {
    if (
      periodicitys &&
      periodicitys.length > 0 &&
      _periodo !== "" &&
      _clasificacion !== ""
    ) {
      // setPeriodo(periodicitys[periodicitys.length - 1].id);
      if (periodicitys.find((e) => e.anio === n)) {
        _getFactor(
          offset,
          limit,
          "",
          _clasificacion,
          periodicitys.find((e) => e.anio === n).id
        );
      } else {
        _getFactor(
          offset,
          limit,
          "",
          _clasificacion,
          periodicitys[periodicitys.length - 1].id
        );
      }
    }
  }, [periodicitys, _periodo, _clasificacion]);

  useEffect(() => {
    if (periodicitys && periodicitys.length > 0) {
      if (periodicitys.find((e) => e.anio === n)) {
        setPeriodo(periodicitys.find((e) => e.anio === n).id);
      } else {
        setPeriodo(periodicitys[periodicitys.length - 1].id);
      }
    }
  }, [periodicitys]);

  const getAClassification = (filt = filter) =>
    dispatch(
      getClassification(
        {
          filter: filt,
        },
        2
      )
    );

  useEffect(() => {
    if (props.match.params.id) {
      _getFactor();
    }
  }, [props.match.params.id]);

  useEffect(() => {
    if (factors.length > 0) {
      var val = 0;
      factors.map((fac) => {
        val = val + parseInt(fac.peso);
      });
      setTotalPesos(val);
    }
  }, [factors]);

  const onAdd = () => {
    if (!props.match.params.id && _empresa !== "" && _clasificacion !== "") {
      setIsOrgSelect(true);
      dispatch(
        getPeriodicityByOrg({
          tipo_busqueda: "empresa__id",
          filter: parseInt(parseInt(_empresa)),
          tipo_busqueda_2: "clasificacion_id",
          filter_2: _clasificacion,
          tipo_busqueda_3: "anio",
          filter_3: parseInt(n),
        })
      );
    } else {
      setIsOrgSelect(false);
    }
    setTotalPesosT(0);
    setDesempeñoT(false);
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    if (!props.match.params.id && item.periodicidad) {
      setIsOrgSelect(true);
      dispatch(
        getPeriodicityByOrg({
          tipo_busqueda: "empresa__id",
          filter: parseInt(item.list_periodicidad[0].empresa),
          tipo_busqueda_2: "clasificacion_id",
          filter_2: parseInt(item.list_periodicidad[0].clasificacion),
          tipo_busqueda_3: "anio",
          filter_3: parseInt(item.list_periodicidad[0].anio),
        })
      );
    }
    setTotalPesosT(0);
    setDesempeñoT(false);
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getFactor(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = async (req) => {
    const _exist = factors.find((f) => f.nombre === req.nombre);
    const _exist1 = factors.find(
      (f) => f.tipo_factor === 1 && f.tipo_factor === parseInt(req.tipo_factor)
    );
    const _exist2 = factors.find(
      (f) => f.tipo_factor === 2 && f.tipo_factor === parseInt(req.tipo_factor)
    );
    if ((_exist1 && !edit) || (_exist2 && !edit)) {
      toastr.info("Solo puede crear un factor para este tipo.");
      return;
    }
    if (
      (_exist1 && edit && _exist1.id !== editItem.id) ||
      (_exist2 && edit && _exist2.id !== editItem.id)
    ) {
      toastr.info("Solo puede crear un factor para este tipo.");
      return;
    }
    if (_exist && !edit) {
      toastr.info("El factor ya existe.");
      return;
    }
    if (_exist && edit && _exist.id !== editItem.id) {
      toastr.info("El factor ya existe.");
      return;
    }
    let tPesos = totalPesos;
    if (edit) {
      tPesos = tPesos - editItem.peso;
    }
    tPesos = tPesos + parseInt(req.peso);
    if (tPesos > 100) {
      setTotalPesosT(tPesos);
    }
    // if (parseInt(req.desempeno_esperado) > parseInt(req.peso)) {
    //   setDesempeñoT(true);
    // } else {
    //   setDesempeñoT(false);
    // }
    if (
      tPesos > 100
      //  || parseInt(req.desempeno_esperado) > parseInt(req.peso)
    ) {
      return;
    }
    let _req = {};

    if (!edit) {
      req.periodicidad = periodicity.id;
      dispatch(saveFactor(req, setShowModal));
    } else {
      if (props.match.params.id) {
        _req = {
          cambio_pesos: [
            {
              encabezado: parseInt(props.match.params.id),
              id_factor: editItem.id_factor,
              peso: req.peso,
            },
          ],
        };
      }
      dispatch(
        editFactor(
          props.match.params.id ? _req : req,
          props.match.params.id ? editItem.id_factor : editItem.id,
          index,
          setShowModal,
          props.match.params.id
        )
      );
    }

    setTotalPesosT(0);
    setTotalPesos(tPesos);
    // setDesempeñoT(false);
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getFactor(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteFactor(id, index));
      window.alert("Se borro este archivo");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      {props.match.params.id ? (
        <>
          <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
        </>
      ) : (
        <>
          <SidebarEvaluacionDesempenio
            show={show}
            onShowSidebar={onShowSidebar}
          />
        </>
      )}

      <div className="custom-wrapper">
        <Container fluid>
          <div
            className={`my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap ${
              props.match.params.id
                ? "justify-content-start"
                : "justify-content-between"
            } align-items-center`}
          >
            {props.match.params.id ? (
              <>
                <Button
                  onClick={() => history.goBack()}
                  variant="link"
                  className="font-weight-bold text-dark"
                >
                  <i className="material-icons">arrow_back</i>
                </Button>
              </>
            ) : null}
            <h5 className="text-black-50 m-0 text-uppercase">
              PESO POR FACTOR
            </h5>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-sm-end align-items-center flex-nowrap">
                {/* <Col>
                  <h6>
                    <b>Busqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col> */}
                {props.match.params.id ? null : (
                  <>
                    <Col xs="auto">
                      <Form.Control
                        name="filter"
                        id="filter"
                        placeholder="Buscar"
                        className="rounded-pill form-control-sm"
                        type="search"
                      ></Form.Control>
                    </Col>
                    <Col xs="auto">
                      <ButtonGroup>
                        <Button
                          onClick={() => seeAll()}
                          variant="light"
                          size="sm"
                          className="rounded-circle mr-1"
                        >
                          <i className="material-icons">list</i>
                        </Button>
                        {userRoles.length > 0 &&
                        userRoles.includes("jefe") &&
                        !(
                          userRoles.includes("administrador") ||
                          userRoles.includes("Responsable_Evaluacion")
                        ) ? null : (
                          <>
                            <Button
                              variant="light"
                              size="sm"
                              className="rounded-circle"
                              onClick={() => onAdd()}
                            >
                              <i className="material-icons">add</i>
                            </Button>
                          </>
                        )}

                        {/* <Dropdown className="mx-1">
                      <Dropdown.Toggle
                        variant="light"
                        className="btn-sm font rounded-pill"
                      >
                        <i className="material-icons">filter_list</i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {filters.map((item) => (
                          <Dropdown.Item
                            onClick={() => setTipoBusqueda(item)}
                            key={item.id}
                          >
                            {item.desc}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown> */}
                      </ButtonGroup>
                    </Col>
                  </>
                )}
              </Row>
            </Form>
          </div>
          {props.match.params.id ? null : (
            <>
              <div className="px-2">
                <hr />
              </div>
              <Col md="12">
                <Row>
                  <Form.Group as={Col} md={4} className="mb-md-1">
                    <Row>
                      <Form.Label column sm={3}>
                        Clasificación
                      </Form.Label>
                      <Col sm={9}>
                        <Row className="d-flex flex-wrap justify-content-start align-items-center">
                          {/* {!loadingClasificacion && (
                            <> */}
                          <Col sm={loadingClasificacion ? "10" : "12"}>
                            <Form.Control
                              as="select"
                              id="clasificacion"
                              name="clasificacion"
                              className="col rounded-pill"
                              defaultValue=""
                              onChange={(e) => {
                                e.preventDefault();

                                setClasificacion(e.currentTarget.value);
                                if (_empresa !== "") {
                                  dispatch(
                                    getPeriodicity({
                                      tipo_busqueda: "empresa__id",
                                      filter: parseInt(_empresa),

                                      tipo_busqueda_2: "clasificacion_id",
                                      filter_2: parseInt(e.currentTarget.value),
                                    })
                                  );
                                }
                                // _getFactor(
                                //   offset,
                                //   limit,
                                //   filter,
                                //   e.currentTarget.value
                                // );
                                //     dispatch(
                                //       getPeriodicity({
                                //        tipo_busqueda: "empresa__id",
                                //        filter: parseInt(e.currentTarget.value),
                                //</Col>     })
                                //   );
                              }}
                            >
                              <option
                                className="text-muted"
                                value=""
                                //  selected
                                //  disabled
                              >
                                Selecionar clasificación
                              </option>
                              {dataClasificacion
                                ? dataClasificacion.length > 0 &&
                                  dataClasificacion
                                    .sort((a, b) =>
                                      a.nombre > b.nombre
                                        ? 1
                                        : b.nombre > a.nombre
                                        ? -1
                                        : 0
                                    )
                                    .map((item) => (
                                      <option key={item.id} value={item.id}>
                                        {item.nombre ? item.nombre : ""}
                                      </option>
                                    ))
                                : ""}
                            </Form.Control>
                          </Col>
                          {/* </>
                          )} */}
                          {loadingClasificacion ? (
                            <Col sm={1}>
                              <Spinner animation="border" size="sm" />
                            </Col>
                          ) : null}
                        </Row>
                      </Col>
                    </Row>
                  </Form.Group>
                  <Form.Group as={Col} md={4} className="mb-md-1">
                    <Row>
                      <Form.Label column sm={3}>
                        Empresa
                      </Form.Label>
                      <Col sm={9}>
                        <Row className="d-flex flex-wrap justify-content-start align-items-center">
                          <Col sm={loadingOrgs ? "10" : "12"}>
                            <Form.Control
                              as="select"
                              id="empresa"
                              name="empresa"
                              className="col rounded-pill"
                              defaultValue=""
                              disabled={loadingOrgs}
                              onChange={(e) => {
                                e.preventDefault();
                                setEmpresa(e.currentTarget.value);
                                if (_clasificacion !== "") {
                                  dispatch(
                                    getPeriodicity({
                                      tipo_busqueda: "empresa__id",
                                      filter: parseInt(e.currentTarget.value),

                                      tipo_busqueda_2: "clasificacion_id",
                                      filter_2: parseInt(_clasificacion),
                                    })
                                  );
                                }
                                // _getMetricByFactor(
                                //   offset,
                                //   limit,
                                //   filter,
                                //   e.currentTarget.value
                                // );
                              }}
                            >
                              <option
                                className="text-muted"
                                value=""
                                selected
                                disabled
                              >
                                Selecionar Empresa
                              </option>
                              {data.length > 0 &&
                                data.map((item) => (
                                  <option key={item.id} value={item.id}>
                                    {item.nombre}
                                  </option>
                                ))}
                            </Form.Control>
                          </Col>
                          {loadingOrgs ? (
                            <Col sm={1}>
                              <Spinner animation="border" size="sm" />
                            </Col>
                          ) : null}
                        </Row>
                      </Col>
                    </Row>
                  </Form.Group>
                  <Form.Group as={Col} md={4} className="mb-md-1">
                    <Row>
                      <Form.Label column sm={3}>
                        Periodicidad
                      </Form.Label>
                      <Col sm={9}>
                        <Row className="d-flex flex-wrap justify-content-start align-items-center">
                          {!loadingPeriodicitys && (
                            <>
                              <Col sm={loadingPeriodicitys ? "10" : "12"}>
                                <Form.Control
                                  as="select"
                                  id="periodicidad"
                                  name="periodicidad"
                                  className="col rounded-pill"
                                  defaultValue={
                                    periodicitys &&
                                    periodicitys.length > 0 &&
                                    periodicitys.find((e) => e.anio === n)
                                      ? periodicitys.find((e) => e.anio === n)
                                          .id
                                      : periodicitys && periodicitys.length > 0
                                      ? periodicitys[periodicitys.length - 1].id
                                      : ""
                                  }
                                  disabled={
                                    loadingPeriodicitys ||
                                    (periodicitys && periodicitys.length === 0)
                                  }
                                  onChange={(e) => {
                                    e.preventDefault();
                                    setPeriodo(e.currentTarget.value);
                                    _getFactor(
                                      offset,
                                      limit,
                                      "",
                                      _clasificacion,
                                      e.currentTarget.value
                                    );
                                  }}
                                >
                                  <option
                                    className="text-muted"
                                    value=""
                                    selected
                                    disabled
                                  >
                                    Selecionar periodicidad
                                  </option>
                                  {periodicitys.length > 0 &&
                                    periodicitys.map((item) => (
                                      <option key={item.id} value={item.id}>
                                        {item.list_frecuencia[0].nombre}
                                        {" - "}
                                        {moment(item.fecha_fin).format(
                                          "DD/MM/YYYY"
                                        )}
                                      </option>
                                    ))}
                                </Form.Control>
                              </Col>
                            </>
                          )}
                          {loadingPeriodicitys ? (
                            <Col sm={1}>
                              <Spinner animation="border" size="sm" />
                            </Col>
                          ) : null}
                        </Row>
                      </Col>
                    </Row>
                  </Form.Group>
                </Row>
              </Col>
            </>
          )}

          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            factorsLength > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable
                      columns={props.match.params.id ? columnsEval : columns}
                      data={factors}
                    />
                  </Card.Body>
                </Card>
                {props.match.params.id ? null : (
                  <>
                    <CustomPagint
                      limit={limit}
                      setLimit={setLimit}
                      offset={offset}
                      setOffset={setOffset}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      dataLenght={factorsLength}
                      pages={pages}
                      pagFunc={_getFactor}
                    />
                  </>
                )}
              </>
            )
          )}
          {!loading && factorsLength === 0 && factorError === "" && (
            <Alert variant="info" className="my-4">
              Aún no hay registros, comience agregando algunos
            </Alert>
          )}
          {!!factorError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {factorError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            // nombre: edit
            //   ? props.match.params.id
            //     ? editItem.nombre_factor
            //     : editItem.nombre
            //   : "",
            factor: edit
              ? editItem.factor
                ? editItem.factor
                : editItem.id_factor
                ? editItem.id_factor
                : ""
              : "",
            peso: edit ? editItem.peso : "",
            tipo_factor: edit ? editItem.tipo_factor : tipo_factor[0].tipo,
            clasificacion: edit ? editItem.clasificacion : _clasificacion,
            empresa: edit
              ? !props.match.params.id && editItem.periodicidad
                ? editItem.periodicidad
                  ? editItem.list_periodicidad[0].empresa
                  : ""
                : ""
              : _empresa,
            // descripcion: edit ? editItem.descripcion : "",
            // desempeno_esperado: edit ? editItem.desempeno_esperado : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit ? "Editar peso por factor" : "Crear peso por factor"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="mt-1 mb-2">
                    {formError}
                  </Alert>
                )}
                {props.match.params.id && (
                  <Alert variant="info" className="mt-1 mb-2">
                    La suma total de los pesos debe ser igual a 100%, El total
                    actual es de {totalPesos}%
                  </Alert>
                )}
                {!loadingPeriodicity &&
                  !edit &&
                  periodicityError === "" &&
                  !periodicity.id &&
                  isOrgSelect &&
                  !props.match.params.id && (
                    <Alert variant="danger" className="mt-1 mb-2">
                      El periodo de evaluación ya cerro o no se ha definido,
                      para mas información comunicarse con el administrador.
                    </Alert>
                  )}
                {!loadingPeriodicity &&
                  !edit &&
                  periodicityError === "" &&
                  periodicity.id &&
                  isOrgSelect &&
                  !props.match.params.id && (
                    <Alert variant="info" className="mt-1 mb-2">
                      Si el periodo de evaluación ya esta siendo utilizado no
                      podra eliminar el registro.
                    </Alert>
                  )}
                {edit &&
                  editItem.list_periodicidad &&
                  editItem.periodicidad &&
                  moment(fecha) >
                    moment(editItem.list_periodicidad[0].fecha_fin) &&
                  !props.match.params.id && (
                    <Alert variant="danger" className="mt-1 mb-2">
                      La plantilla ya ha cerrado.
                    </Alert>
                  )}
                {!props.match.params.id &&
                  (_clasificacion === "" || _empresa === "") && (
                    <Alert variant="danger" className="mt-1 mb-2">
                      Debe seleccionar una clasificación y una empresa
                      previamente, para poder agregar un nuevo registro.
                    </Alert>
                  )}
                {!props.match.params.id && (
                  <>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        Empresa
                      </Form.Label>
                      <Col sm={9}>
                        <Row className="d-flex flex-wrap justify-content-start align-items-center">
                          <Col
                            sm={loadingOrgs || loadingPeriodicity ? "10" : "12"}
                          >
                            <Form.Control
                              as="select"
                              id="empresa"
                              name="empresa"
                              className="col rounded-pill"
                              isInvalid={touched.empresa && errors.empresa}
                              isValid={touched.empresa && !errors.empresa}
                              onBlur={handleBlur("empresa")}
                              value={values.empresa}
                              // defaultValue={empresa}
                              // disabled={
                              //   edit ||
                              //   loadingOrgs ||
                              //   loadingPeriodicity ||
                              //   (edit && moment(fecha) > moment(editItem.fecha_fin))
                              // }
                              disabled
                              onChange={(e) => {
                                dispatch(
                                  getPeriodicityByOrg({
                                    tipo_busqueda: "empresa__id",
                                    filter: parseInt(e.currentTarget.value),
                                  })
                                );
                                if (e.currentTarget.value !== "") {
                                  setIsOrgSelect(true);
                                } else {
                                  setIsOrgSelect(false);
                                }
                                handleChange(e);
                              }}
                            >
                              <option
                                className="text-muted"
                                value=""
                                selected
                                disabled
                              >
                                Selecionar Empresa
                              </option>
                              {data.length > 0 &&
                                data.map((item) => (
                                  <option key={item.id} value={item.id}>
                                    {item.nombre}
                                  </option>
                                ))}
                            </Form.Control>
                          </Col>
                          {loadingOrgs || loadingPeriodicity ? (
                            <Col sm={1}>
                              <Spinner animation="border" size="sm" />
                            </Col>
                          ) : null}
                        </Row>
                        {touched.empresa && errors.empresa && (
                          <Col>
                            <small className="text-danger">
                              {errors.empresa}
                            </small>
                          </Col>
                        )}
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        Clasificacion
                      </Form.Label>
                      <Col sm={9}>
                        <Row>
                          <Col sm={12}>
                            <Form.Control
                              as="select"
                              id="clasificacion"
                              name="clasificacion"
                              className="col rounded-pill"
                              isInvalid={
                                touched.clasificacion && errors.clasificacion
                              }
                              isValid={
                                touched.clasificacion && !errors.clasificacion
                              }
                              onBlur={handleBlur("clasificacion")}
                              value={values.clasificacion}
                              disabled
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            >
                              <option
                                className="text-muted"
                                value=""
                                selected
                                disabled
                              >
                                Selecionar clasificacion
                              </option>
                              {dataClasificacion
                                ? dataClasificacion.length > 0 &&
                                  dataClasificacion.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.nombre ? item.nombre : ""}
                                    </option>
                                  ))
                                : ""}
                            </Form.Control>
                            {touched.clasificacion && errors.clasificacion && (
                              <Col>
                                <small className="text-danger">
                                  {errors.clasificacion}
                                </small>
                              </Col>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Form.Group>
                  </>
                )}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Nombre factor
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm={loadingFactorName ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          id="factor"
                          name="factor"
                          className="col rounded-pill"
                          isInvalid={touched.factor && errors.factor}
                          isValid={touched.factor && !errors.factor}
                          onBlur={handleBlur("factor")}
                          value={values.factor}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          disabled={
                            props.match.params.id ||
                            (edit &&
                              editItem.periodicidad &&
                              n !== editItem.list_periodicidad[0].anio)
                          }
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          >
                            Selecionar factor
                          </option>
                          {factorName &&
                            factorName.count > 0 &&
                            factorName.data.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.nombre ? item.nombre : ""}
                              </option>
                            ))}
                        </Form.Control>
                      </Col>
                      {loadingFactorName ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                    {touched.factor && errors.factor && (
                      <Col>
                        <small className="text-danger">{errors.factor}</small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                {/* <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Nombre
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={12}>
                        <Form.Control
                          id="nombre"
                          name="nombre"
                          isInvalid={touched.nombre && errors.nombre}
                          isValid={touched.nombre && !errors.nombre}
                          onBlur={handleBlur("nombre")}
                          onChange={handleChange}
                          value={values.nombre}
                          className="rounded-pill"
                          type="text"
                          placeholder="Nombre"
                          disabled={
                            props.match.params.id ||
                            (edit &&
                              editItem.periodicidad &&
                              n !== editItem.list_periodicidad[0].anio)
                          }
                        ></Form.Control>
                        {touched.nombre && errors.nombre && (
                          <div>
                            <small className="text-danger">
                              {errors.nombre}
                            </small>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Form.Group> */}
                {/* <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Descripción
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={12}>
                        <Form.Control
                          id="descripcion"
                          name="descripcion"
                          isInvalid={touched.descripcion && errors.descripcion}
                          isValid={touched.descripcion && !errors.descripcion}
                          onBlur={handleBlur("descripcion")}
                          onChange={handleChange}
                          value={values.descripcion}
                          className="rounded-pill"
                          type="text"
                          placeholder="Descripcion"
                          disabled={
                            props.match.params.id ||
                            (edit &&
                              editItem.periodicidad &&
                              n !== editItem.list_periodicidad[0].anio)
                          }
                        ></Form.Control>
                        {touched.descripcion && errors.descripcion && (
                          <div>
                            <small className="text-danger">
                              {errors.descripcion}
                            </small>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Form.Group> */}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Peso
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col>
                        <Form.Control
                          id="peso"
                          name="peso"
                          isInvalid={
                            touched.peso && (errors.peso || totalPesosT > 100)
                          }
                          isValid={touched.peso && !errors.peso}
                          onBlur={handleBlur("peso")}
                          onChange={handleChange}
                          value={values.peso}
                          className="rounded-pill"
                          type="number"
                          placeholder="0"
                          min={0}
                          max={100}
                          disabled={
                            !props.match.params.id &&
                            edit &&
                            editItem.periodicidad &&
                            n !== editItem.list_periodicidad[0].anio
                          }
                          // step={1}
                        ></Form.Control>
                      </Col>
                    </Row>
                    {touched.peso && errors.peso && (
                      <Col>
                        <small className="text-danger">{errors.peso}</small>
                      </Col>
                    )}
                    {totalPesosT > 100 && (
                      <Col>
                        <small className="text-danger">
                          ** La suma total de pesos no puede ser mayor a 100.
                          (total = {totalPesosT})
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Tipo de factor
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm="12">
                        <Form.Control
                          as="select"
                          id="tipo_factor"
                          name="tipo_factor"
                          className="col rounded-pill"
                          isInvalid={touched.tipo_factor && errors.tipo_factor}
                          isValid={touched.tipo_factor && !errors.tipo_factor}
                          onBlur={handleBlur("tipo_factor")}
                          value={values.tipo_factor}
                          onChange={handleChange}
                          disabled={
                            props.match.params.id ||
                            (edit &&
                              editItem.periodicidad &&
                              n !== editItem.list_periodicidad[0].anio)
                          }
                        >
                          {tipo_factor.map((item) => (
                            <option key={item.tipo} value={item.tipo}>
                              {item.tipo} - {item.nombre}
                            </option>
                          ))}
                        </Form.Control>
                      </Col>
                    </Row>
                    {touched.tipo_factor && errors.tipo_factor && (
                      <Col>
                        <small className="text-danger">
                          {errors.tipo_factor}
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                {/* <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Desempeño esperado
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col>
                        <Form.Control
                          id="desempeno_esperado"
                          name="desempeno_esperado"
                          isInvalid={
                            touched.desempeno_esperado &&
                            (errors.desempeno_esperado || desempeñoT)
                          }
                          isValid={
                            touched.desempeno_esperado &&
                            !errors.desempeno_esperado
                          }
                          onBlur={handleBlur("desempeno_esperado")}
                          onChange={handleChange}
                          value={values.desempeno_esperado}
                          className="rounded-pill"
                          type="number"
                          placeholder="0"
                          min={0}
                          max={100}
                          // step={1}
                        ></Form.Control>
                      </Col>
                    </Row>
                    {touched.desempeno_esperado && errors.desempeno_esperado && (
                      <Col>
                        <small className="text-danger">
                          {errors.desempeno_esperado}
                        </small>
                      </Col>
                    )}
                    {desempeñoT && (
                      <Col>
                        <small className="text-danger">
                          ** El desempeño no puede ser mayor al peso ingresado.
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group> */}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                {!props.match.params.id &&
                edit &&
                editItem.periodicidad &&
                n !== editItem.list_periodicidad[0].anio ? null : ( //   moment(editItem.list_periodicidad[0].fecha_fin) // moment(fecha) >
                  <>
                    <Button
                      className="rounded-pill"
                      // disabled={
                      //   saveLoading ||
                      //   (!loadingPeriodicity &&
                      //     !edit &&
                      //     periodicityError === "" &&
                      //     !periodicity.id &&
                      //     isOrgSelect) ||
                      //   (!props.match.params.id &&
                      //     edit &&
                      //     moment(fecha) >
                      //       moment(editItem.list_periodicidad[0].fecha_fin)) ||
                      //   loadingOrgs ||
                      //   loadingPeriodicity ||
                      //   (!props.match.params.id && values.empresa === "") ||
                      //   (!props.match.params.id && values.clasificacion === "")
                      // }
                      disabled={!edit && !periodicity.id}
                      variant="primary"
                      type="submit"
                    >
                      {saveLoading && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      Guardar
                    </Button>
                  </>
                )}
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default Factor;
